/**
 * Constants and Configuration for Query Parser
 */

"use strict";

// Check if debug mode is enabled (global)
export const urlParams = new URLSearchParams(window.location.search);
export const debugMode = urlParams.get('debug') || '0';

// Boost values for pattern matching priority
export const BOOST_EXACT_PHRASE = 5;    // Quoted phrases - highest priority
export const BOOST_ROMAN_NUMERAL = 3;  // Roman numeral match
export const BOOST_SYNONYM = 3;        // Synonym patterns (OT/PC/ПК/etc) - medium-high priority
export const BOOST_REGEX = 2;          // Matches found by regex patterns
export const BOOST_REGULAR_TERM = 1;   // Regular term match
export const BOOST_EXACT_PHRASE_AUTO = 5; // Auto-generated exact phrase (same as quoted)

// Use String.raw to preserve ALL backslashes for Unicode escapes in RegExp constructor
export const UNI_B_START = String.raw`(?<![\p{L}\p{N}])`;
export const UNI_B_END = String.raw`(?![\p{L}\p{N}])`;
